import { createUserRules } from "../helpers";
import { LEGAL_CAN_PERMISSION_MAPPING } from "./permissions";

export const LegalUserRules = createUserRules(LEGAL_CAN_PERMISSION_MAPPING);
